import _ from "lodash";
import {
  Component,
} from "react";
import store from "CommonState/store";
import uiconfig from "CommonState/uiconfig";
import {
  formatValue,
  Awesome,
  Panel,
  Spinner,
} from "CommonComponents/bricks";
import {
  Table,
  Button,
  Alert,
} from "react-bootstrap";
import apifetch, {
  getApiHeaders,
} from "CommonCore/apifetch";
import {
  ANTRAGSTATUS,
  ANTRAGSTELLERMODUS,
  ASTMODUSKEY,
  getModusFromAntrag,
  ROLLEN,
} from "App/constants";
import ContextHelpButton from "Components/context-help";
import DokumentWidget from "Components/dokument-widget";
import DokumentGruppeWidget from "Components/dokument-gruppe-widget";

export default
@uiconfig
@store("user", "flag_antragstellermodus")
class AntragDokumenteWidget extends Component {
  constructor() {
    super();
    this.state = {};
  }

  load = async function(antrag) {
    // Dokumente zum Antrag laden
    if (antrag && antrag.a_id && antrag.a_id != "undefined") {
      const liste = await apifetch(`/api/shkantrag/antrag/dokliste/${ antrag.a_id }`);
      this.setState({ liste: liste.data, downloadError: undefined });
    }
  };

  componentDidMount = () => {
    this.load(this.props.antrag);
  };

  componentDidUpdate = prevProps => {
    if (prevProps.antrag !== this.props.antrag) {
      this.load(this.props.antrag);
    }
  };

  render() {
    let { liste } = this.state;
    const { downloadingZip, downloadError } = this.state;
    const { user, antrag } = this.props;

    if (!liste) {
      return <Spinner />;
    }
    liste = _.cloneDeep(liste);
    liste.push({ newRow: true, kpf_id: null, requireName: true, url_upload: "shkantrag/dokument/upload" });

    const istVertrag = dokument => {
      // Prüfen ob das Dokument unter Rubrik "Vertrag" soll.
      return dokument.url_download && (dokument.url_download.indexOf("/VERTRAG") >= 0 || dokument.url_download.indexOf("/AENDERUNGSVERTRAG") >= 0 || dokument.url_download.indexOf("NIEDERSCHRIFT") >= 0);
    };

    // Liste nach Art Gruppieren
    const pflichtarten = _.groupBy(_.orderBy(liste.filter(item => item.kpf_id && item.spf_verpflichtend), "dol_pos"), item => item.kpf_id);
    const pflichtartenZutreffend = _.groupBy(_.orderBy(liste.filter(item => item.kpf_id && !item.spf_verpflichtend), "dol_pos"), item => item.kpf_id);
    const sonstigeAnlagen = _.groupBy(liste.filter(item => item.anhang), item => item.kpf_id);

    const antragsteller = user.ro_id == ROLLEN.ROLLE_ANTRAGSTELLER;
    const eingereicht = !!antrag.a_eingangsdat;

    // PBP-2003: Wenn Vertrag bei Dezernat4 unterzeichnet wird, wird er hier ausgeblendet
    const istUnterzeichnungDez4 = antrag.a_asid == ANTRAGSTATUS.STATUS_UNTERZEICHNUNG_DEZ4;

    const getHelpContent = tag => {
      return this.state[tag] && this.state[tag].showHelp && <div style={{ padding: "8px", border: "1px solid", borderRadius: "4px", backgroundColor: "#fcf8e3", borderColor: "#faebcc" }}>{formatValue(this.state[tag].helpContent, { type: "markdown", field: "text" })}</div>;
    };

    const HelpButton = ({ tag }) => {
      return <ContextHelpButton style={{ margin: "5px" }} onClick={this.toggleHelp(tag)} custompath={`${ window.location.pathname }#${ tag }`} />;
    };

    const renderRow = (dol, downloadTooltip, prominent, index = 0) => <DokumentWidget
      key={dol.dol_dokid || `row-${ dol.kpf_id }-${ index }` || `fallback-${ index }`}
      downloadTooltip={downloadTooltip}
      downloadProminent={prominent}
      name={dol.dol_bez}
      urlupload={dol.url_upload}
      urldownload={dol.url_download}
      filename={dol.dok_dateiname}
      requireName={dol.requireName}
      afterUpload={this.afterUpload}
      readonly={!antragsteller && !dol.newRow}
      params={{ a_id: antrag.a_id, ado_kpfid: dol.kpf_id, dok_name: dol.dol_kbez, dok_id: dol.dol_dokid, b_id: dol.b_id }}
      urlemptytext={antragsteller ? "Bitte in Papierform beilegen" : "In Papierform"} />;

    const renderVertragRow = dol => renderRow(dol, "Vertrag zum Drucken herunterladen", true);

    const renderGroup = (array, groupIndex) => {
      const dol = array[0];
      return <tr key={`group-${ dol.kpf_id }-${ groupIndex }`}><td><DokumentGruppeWidget
        key={dol.dol_id}
        name={dol.dol_kbez}
        notation={dol.dol_bez == dol.dol_kbez ? "" : dol.dol_bez}
        items={array}
        afterUpload={this.afterUpload}
        urlupload={dol.url_upload}
        readonly={!antragsteller}
        params={{ a_id: antrag.a_id, ado_kpfid: dol.kpf_id, dok_name: dol.dol_kbez, dok_id: dol.dol_dokid, b_id: dol.b_id }}
      /></td></tr>;
    };

    let modus = ANTRAGSTELLERMODUS[this.props.flag_antragstellermodus];
    if (!modus) {
      modus = ANTRAGSTELLERMODUS[getModusFromAntrag(antrag)];
    }

    // Arbeitsvertrag für Tarif ausblenden
    const istTarif = modus.value == ASTMODUSKEY.Tarif;

    const listeVertrag = _.filter(liste, item => istVertrag(item) && item.url_download && !item.url_upload);
    const listeWeiterPflichtanlagen = _.filter(liste, item => !item.anhang && !item.url_download && !item.url_upload);
    let headerText = "";
    if (!_.isEmpty(listeVertrag)) {
      headerText = `${ modus.labelVertrag } und zugehörige Anlagen`;
    } else {
      headerText = "Anlagen";
    }

    const downloadbareDokumente = _.filter(liste, item => item.url_download);

    return <div className='box-panel'>
      {!antragsteller && (
        <div style={{ textAlign: "right", marginBottom: "8px" }}>
          <Button
            variant='outline-primary'
            size='sm'
            disabled={downloadingZip || _.isEmpty(downloadbareDokumente)}
            onClick={() => this.downloadAll(downloadbareDokumente)}
          >
            <Awesome name='file-archive' />{" "}
            {downloadingZip ? "ZIP wird erstellt..." : "Alle Dokumente herunterladen"}
          </Button>
        </div>
      )}
      {downloadError && <Alert variant='danger'>{downloadError}</Alert>}

      {eingereicht && (
        <Panel header={<h3>{headerText}{"\u00a0"}<HelpButton tag='anlagenvertrag' /></h3>}>
          {getHelpContent("anlagenvertrag")}
          {antragsteller && <span><b>Hinweis:</b> Die im Folgenden aufgeführten Dokumente werden erst relevant, wenn der Antrag im Personaldezernat geprüft und freigegeben wurde</span>}
          <br />
          { (!_.isEmpty(listeVertrag) && ((!istUnterzeichnungDez4 && !istTarif) || !antragsteller)) &&
            <Table striped>
              <thead><tr><th>{ modus.labelVertrag }</th><th className='td-aktionen'>Aktionen</th></tr></thead>
              <tbody>
                {_.filter(liste, item => istVertrag(item) && item.url_download && !item.url_upload).map(dol => renderVertragRow(dol))}
              </tbody>
            </Table>
          }
          <Table striped>
            <thead><tr><th>Vorlagen für Anlagen zum { modus.labelVertrag }</th><th className='td-aktionen'>Aktionen</th></tr></thead>
            <tbody>
              {_.filter(liste, item => !item.anhang && item.url_download && !item.url_upload && !istVertrag(item)).map((dol, index) => renderRow(dol, "", false, index))}
            </tbody>
          </Table>
          { (modus.value != ASTMODUSKEY.Lehrauftrag && !_.isEmpty(listeWeiterPflichtanlagen)) &&
            <Table striped>
              <thead><tr><th>Weitere Pflichtanlagen für den { modus.labelVertrag }</th><th className='td-aktionen' /></tr></thead>
              <tbody>
                { listeWeiterPflichtanlagen.map(dol => renderRow(dol))}
              </tbody>
            </Table>
          }
        </Panel>)}


      <Panel header={<h3>Anlagen zum Antrag{"\u00a0"}<HelpButton tag='anlagenantrag' /> </h3>}>
        {getHelpContent("anlagenantrag")}
        {antragsteller && (modus.value === ASTMODUSKEY.Hilfskraft) && <p>Folgende Dokumente sind dem Antrag beizufügen.</p>}
        {antragsteller && (modus.value !== ASTMODUSKEY.Hilfskraft) && <p>Folgende Dokumente sind dem Antrag beizufügen. Einige davon sind zum Download und Ausfüllen hinterlegt, andere müssen als Kopie in Papierform beigelegt werden</p>}
        {antragsteller && <p><b>Hinweis:</b> Für das Hochladen sind nur Dokumente im PDF-Format zugelassen.</p>}

        {!_.isEmpty(pflichtarten) &&
        <table width='100%'>
          <thead>
            <tr>
              <th><h4>Elektronische Pflichtanlagen zum Antrag</h4></th>
            </tr>
          </thead>
          <tbody style={{ paddingLeft: "2em" }}>
            {_.map(pflichtarten, (group, key) => renderGroup(group, `pflicht-${ key }`))}
          </tbody>
        </table>}
        {
          !_.isEmpty(pflichtartenZutreffend) && <table width='100%'>
            <thead>
              <tr>
                <th><h4>Elektronische Pflichtanlagen (wenn zutreffend)</h4></th>
              </tr>
            </thead>
            <tbody style={{ paddingLeft: "2em" }}>
              {_.map(pflichtartenZutreffend, (group, key) => renderGroup(group, `zutreffend-${ key }`))}
            </tbody>
          </table>
        }

        <table width='100%'>
          <thead>
            <tr>
              <th><h4>Zusätzliche elektronische Anlagen zum Antrag</h4></th>
            </tr>
          </thead>
          <tbody>
            {_.map(_.isEmpty(sonstigeAnlagen) ? { 0: [{ dol_id: 0, ado_kpfid: null }] } : sonstigeAnlagen, (group, key) => renderGroup(group, `sonstige-${ key }`))}
          </tbody>
        </table>
      </Panel>

    </div>;
  }


  afterUpload = () => {
    // hier an den Antrag hochladen
    const { antrag } = this.props;
    this.load(antrag);
  };

  toggleHelp = tag => content => {
    // Hilfebereich togglen
    const data = this.state[tag] || { showHelp: false, helpContent: {} };
    data.helpContent.text = content;
    data.showHelp = !data.showHelp;
    this.setState({ [tag]: data });
  };

  downloadAll = async docs => {
    if (_.isEmpty(docs)) {
      this.setState({ downloadError: "Keine downloadbaren Dokumente vorhanden." });

      return;
    }
    this.setState({ downloadingZip: true, downloadError: undefined });
    try {
      const response = await fetch("/api/shkantrag/dokument/zip", {
        method: "POST",
        headers: { ...getApiHeaders(), "Content-Type": "application/json" },
        body: JSON.stringify({ data: docs }),
      });
      if (!response.ok) {
        this.setState({ downloadError: `Fehler beim ZIP-Download (${ response.status })` });
      }
      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.download = "Anlagen.zip";
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
    } catch(err) {
      this.setState({ downloadError: err.message || "Fehler beim ZIP-Download" });
    } finally {
      this.setState({ downloadingZip: false });
    }
  };
}
